import React from 'react';
import { Link } from 'react-router-dom';
import Div from '../Div';
import './portfolio.scss';

const WHATSAPP_NUMBER = '971544905157';

export default function Portfolio({ href, src, title, subtitle, variant }) {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(`Hello, I'm interested in "${title}". Please share more details.`)}`;

  return (
    <Div className={`cs-portfolio cs-bg ${variant ? variant : 'cs-style1'}`} style={{ position: 'relative' }}>
      <Link to={href}>
        <Div className="cs-portfolio_hover" />
        <Div
          className="cs-portfolio_bg cs-bg"
          style={{ backgroundImage: `url("${src}")` }}
        />
        <Div className="cs-portfolio_info">
          <Div className="cs-portfolio_info_bg cs-accent_bg" />
          <h2 className="cs-portfolio_title">{title}</h2>
          <Div className="cs-portfolio_subtitle">{subtitle}</Div>
        </Div>
      </Link>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noreferrer"
        className="cs-portfolio_whatsapp"
        onClick={(e) => e.stopPropagation()}
        title="Get a quote via WhatsApp"
      >
        <svg width="20" height="20" viewBox="0 0 448 512" fill="#fff" xmlns="http://www.w3.org/2000/svg">
          <path d="M380.9 97.1C339 55.1 283.2 32 224.8 32 106.1 32 8 130.1 8 248c0 43.9 11.6 86.3 33.6 123.4L0 480l111.7-40.9c35.3 19.2 74.9 29.4 115.1 29.4h0.1c118.7 0 216.8-98.1 216.9-216 0-58.4-23.1-114.1-65-156.9zM224.8 438.6h-.1c-36.1 0-71.5-9.7-102.5-28.1l-7.4-4.4-66.2 24 22.5-68.3-4.8-7.1C44.2 322.9 33 286.1 33 248 33 142.6 119.4 56.1 224.8 56.1c58.6 0 113.8 22.8 155.2 64.2 41.4 41.5 64.2 96.7 64.1 155.3-.1 105.3-86.6 192.9-192.3 192.9zm107.7-138.1c-5.9-3-35.1-17.3-40.6-19.3-5.5-2-9.5-3-13.5 3s-15.5 19.3-19 23.2c-3.5 4-7 4.5-12.9 1.5-5.9-3-24.9-9.2-47.4-29.4-17.5-15.6-29.2-34.9-32.6-40.8-3.4-6-0.4-9.2 2.6-12.1 2.7-2.6 6-6.7 9-10.1 3-3.4 4-5.9 6-9.9 2-4 1-7.4-.5-10.4-1.5-3-13.5-32.4-18.5-44.3-4.9-11.8-9.9-10.2-13.5-10.4-3.5-.2-7.5-.2-11.5-.2s-10.5 1.5-16 7.4c-5.5 5.9-21 20.5-21 50s21.5 57.9 24.5 61.9c3 4 42.3 64.6 102.5 90.6 14.3 6.2 25.4 9.9 34.1 12.7 14.3 4.5 27.3 3.8 37.6 2.3 11.5-1.7 35.1-14.3 40-28.1 5-13.8 5-25.6 3.5-28.1-1.5-2.5-5.4-4-11.3-7z"/>
        </svg>
      </a>
    </Div>
  );
}
